export default "__VITE_ASSET__BgtYGy2I__"